import { updatePageData, trackAdHocEvent } from '@rdss/core'
import { Component, Event, EventEmitter, Host, Prop, Watch, h } from '@stencil/core'
import { VariantSwitchItem } from './types'
import { Snippets } from './types/snippets'

const DefaultSnippets: Snippets = {
    VariantTitle: 'Varianten',
}

@Component({
    tag: 'zr-variant-switch',
    styleUrl: './zr-variant-switch.scss',
    scoped: true,
})
/**
 * Variant Switch Component.
 */
export class ZrVariantSwitch {
    /**
     * Snippets.
     */
    @Prop({ mutable: true }) snippets?: Snippets = DefaultSnippets

    /**
     * Variants.
     */
    @Prop() variants: VariantSwitchItem[]

    /**
     * Locale used for currencies.
     */
    @Prop() locale: string

    /**
     * Show only the variant with the given id.
     */
    @Prop() showVariantOnly: string | undefined

    /**
     * Emits when a variant is changed.
     */
    @Event() variantChanged: EventEmitter<{ sku: number }>

    /**
     * Watches for snippet changes and merges the default values with the
     * new prop values.
     */
    @Watch('snippets')
    setSnippets(newVal: Snippets, oldVal: Snippets) {
        if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
            this.snippets = { ...this.snippets, ...newVal }
        }
    }

    /**
     * Handles the variant click event.
     *
     * @param {VariantSwitchItem} variant - The clicked variant.
     */
    variantClicked = (variant: VariantSwitchItem) => {
        if (!variant.selected && variant.isAvailable) {
            this.variantChanged.emit({ sku: variant.id })
            const urlPath = new URL(variant.url).pathname
            history.pushState({}, '', urlPath)
            updatePageData('variantClicked', variant.id)
            trackAdHocEvent('pageView')
        }
    }

    /**
     * Checks if component has variants text.
     */
    hasVariantsText(): boolean {
        return this.variants.length > 1 || this.variants.some(variant => variant.text)
    }

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (
            <Host>
                <form>
                    <filedset>
                        {this.hasVariantsText() &&
                        <div>
                            <legend class="zr-variant-switch__legend">{this.snippets.VariantTitle}</legend>
                            {this.variants.map(variant => (
                                (!this.showVariantOnly || this.showVariantOnly === variant.id.toString()) &&
                                <zr-variant-switch-list-item
                                    hasLowestPricePerUnit={variant.hasLowestPricePerUnit}
                                    variant={variant}
                                    locale={this.locale}
                                    onClick={() => this.variantClicked(variant)}
                                />
                            ))}
                        </div>
                        }
                    </filedset>
                </form>
            </Host>
        )
    }
}
